import React from 'react';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import _ from 'lodash';

// import Link from "./Triggers/Link/Link";
import Input from './Triggers/Input/Input';
import Option from './Option/Option';
import Checkbox from '@/components/common/Checkbox/Checkbox';

class Multiple extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      selected: [],
      anchorEl: null,
      showSelected: true,
      inputValue: '',
      all: false,
    };
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      selected: [],
      options: this.props.options,
    });
  }

  shouldComponentUpdate(nextProps) {
    if (!_.isEqual(nextProps.options, this.props.options)) {
      this.setState({ ...this.state, options: nextProps.options });
    }

    if (
      !_.isEqual(nextProps.isClose, this.props.isClose) &&
      nextProps.isClose === true
    ) {
      this.setState({
        ...this.state,
        selected: [],
        anchorEl: null,
        inputValue: '',
      });
    }

    if (!_.isEqual(nextProps.selected, this.props.selected)) {
      this.setState({ ...this.state, selected: nextProps.selected });
    }
    if (
      !_.isEqual(nextProps.isOpen, this.props.isOpen) &&
      nextProps.isOpen === true &&
      nextProps.anchorEl
    ) {
      this.setState({
        ...this.state,
        anchorEl: nextProps.anchorEl,
        inputValue: '',
        options: this.props.options,
      });
    }
    return true;
  }

  render() {
    const { props, state } = this;
    const open = Boolean(state.anchorEl);

    const handleClick = (event) => {
      this.setState(
        {
          ...this.state,
          anchorEl: event.currentTarget,
          inputValue: '',
          options: this.props.options,
        },
        () => {
          if (props.onOpen) {
            props.onOpen();
          }
        }
      );
    };

    const handleClose = () => {
      this.setState({ ...this.state, anchorEl: null });
      if (props.onBlur) {
        props.onBlur();
      }
    };

    const handleStateUpdate = (update, cb) => {
      this.setState({ ...this.state, ...update }, cb);
    };

    const handleSelectAll = () => {
      const isAll = !this.state.all;
      if (isAll) {
        this.setState({
          ...this.state,
          selected: this.props.options,
          all: isAll,
        });
        props.onChange(this.props.options, 'all');
      } else {
        this.setState({ ...this.state, selected: [], all: isAll });
        props.onChange([], 'all');
      }
    };

    return (
      <div
        class={`selectContainer multipleSelection ${props.classes.main} ${props.isSearchable ? 'searchable' : ''}`}
        data-tip
        data-for={props.tooltipID}
      >
        <div class="selectedValue">
          <div
            class={`selectedTrigger ${props.open ? 'active' : ''}  ${props.iconOnly ? 'hide' : ''}`}
          >
            <a onClick={handleClick}>
              {state.selected.length > 0 && (
                <div class="selectedItems">
                  {props.showSelectedInInput &&
                  props.renderSelected &&
                  state.selected.length > 0
                    ? state.selected.map((s) => props.renderSelected(s))
                    : props.renderCustomSelected
                      ? props.renderCustomSelected(state.selected)
                      : state.selected.map((s, i) => (
                          <span>
                            {s.label}
                            {i + 1 < state.selected.length ? ', ' : ''}
                          </span>
                        ))}
                </div>
              )}
              {state.selected.length === 0 && <span>{props.placeholder}</span>}
              <i class="material-icons">arrow_drop_down</i>
            </a>
          </div>
        </div>
        <Popper
          open={open}
          anchorEl={state.anchorEl}
          placement="bottom-start"
          style={{ zIndex: 1053 }}
        >
          <ClickAwayListener onClickAway={handleClose}>
            <div class={`optionsContainer ${props.classes.options}`}>
              {props.isSearchable && (
                <Input
                  state={state}
                  open={open}
                  options={props.options}
                  placeholder={props.placeholder}
                  showSelectedInInput={props.showSelectedInInput}
                  renderSelected={props.renderSelected}
                  onTrigger={handleClick}
                  onUpdateState={handleStateUpdate}
                  onOpen={props.onOpen}
                  onSearch={props.onSearch}
                  onClearSelected={props.onClearSelected}
                  value={this.state.inputValue}
                />
              )}
              <div class={`selectOptions ${props.classes.options}`}>
                {props.includeSelectAll && props.options.length > 0 && (
                  <div class="selectOption">
                    <div class="optionTrigger">
                      <Checkbox
                        checked={
                          this.state.selected.length ===
                          this.props.options.length
                        }
                        onChange={handleSelectAll}
                      />
                      <span>
                        {props.selectAllLabel ? props.selectAllLabel : 'All'}
                      </span>
                    </div>
                  </div>
                )}
                {state.options.length > 0 &&
                  !props.isLoading &&
                  state.options.map((option) => {
                    return (
                      <Option
                        key={`selectOptionKey_${option.value}`}
                        option={option}
                        selected={state.selected}
                        closeOnChange={props.closeOnChange}
                        renderOption={props.renderOption}
                        onUpdateState={handleStateUpdate}
                        onChange={props.onChange}
                        onClose={handleClose}
                      />
                    );
                  })}
                {this.state.options.length === 0 && !props.isLoading && (
                  <div class="selectOption">
                    <div class="optionTrigger">
                      <span>No Results Found</span>
                    </div>
                  </div>
                )}
                {props.isLoading && (
                  <div class="selectOption">
                    <div class="optionTrigger">
                      <span>Loading...</span>
                    </div>
                  </div>
                )}
                {props.bottomContent && (
                  <div class="selectBottomContent">{props.bottomContent}</div>
                )}
              </div>
            </div>
          </ClickAwayListener>
        </Popper>
      </div>
    );
  }
}

Multiple.defaultProps = {
  options: [{ value: '', label: 'No options' }],
  closeOnChange: true,
  classes: {
    main: '',
    options: '',
  },
  selected: {},
  showSelectedInInput: true,
  showSelectedInOptions: true,
  exclude: [],
  placeholder: 'Select',
  isFirstItemSelected: true,
};

export default Multiple;
